var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVitruvianMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.9,107.18a75.28,75.28,0,1,1-75.28-75.27,75.29,75.29,0,0,1,75.28,75.27"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108.62,
    cy: 107.18,
    r: 75.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.1,78l-10-28.32-8.42,2.81,18,52.17L93,170.88h9.56V138.53H112v32.35h9.55V104.62l18.28-53.29-8.42-2.81L121.08,78Zm24.66-18.8A9.88,9.88,0,1,1,107.88,49,10,10,0,0,1,117.76,59.16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitruvianMan);
export default __webpack_public_path__ + "static/media/VITRUVIAN_MAN.4afebf76e1a9cf189e926bc239595f8f.svg";
export { ForwardRef as ReactComponent };